/**
 * Tarih yardımcı fonksiyonları - Türkiye saat dilimine göre
 */

/**
 * Tarihi YYYY-MM-DD formatında döndürür (yerel saat dilimine göre)
 * @param {Date} date - Date objesi
 * @returns {string} YYYY-MM-DD formatında tarih
 */
export const formatDateToLocal = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Bugünün tarihini YYYY-MM-DD formatında döndürür
 * @returns {string} Bugünün tarihi
 */
export const getTodayLocal = () => {
  return formatDateToLocal(new Date());
};

/**
 * Saati HH:MM formatında döndürür (yerel saat dilimine göre)
 * @param {Date} date - Date objesi
 * @returns {string} HH:MM formatında saat
 */
export const formatTimeToLocal = (date = new Date()) => {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
};

/**
 * Şimdiki saati HH:MM formatında döndürür
 * @returns {string} Şimdiki saat
 */
export const getCurrentTimeLocal = () => {
  return formatTimeToLocal(new Date());
};

/**
 * String tarihten Date objesi oluşturur (yerel saat dilimine göre)
 * @param {string} dateStr - YYYY-MM-DD formatında tarih
 * @returns {Date} Date objesi
 */
export const parseLocalDate = (dateStr) => {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
};
